import React from 'react'

import * as THREE from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'

import pill from "./../../../UI/general/pill.svg"

interface Viewer360ThreeMobile {
  mountRef: any,
}

interface Props {
  isViewer360: boolean,
  handleCloseGallery: any,
  colorsData: any,
  amenityData: any,
}

interface State {
  isTouchScreen: boolean,
  zoom: number,
  zoomValue: number,
  isCollapsed: boolean,
  currentImage: string,
  currentSelectedtourIndex: number,
  rerender: boolean,
  show: boolean
}


const scene = new THREE.Scene()
scene.background = new THREE.Color(0x000000)

class Viewer360ThreeMobile extends React.Component<Props,State>{

  constructor(props: Props){
    super(props);
    this.state = {
      isTouchScreen: false,
      zoom: 80,
      zoomValue: 0,
      isCollapsed: false,
      currentImage: "",
      currentSelectedtourIndex: 0,
      rerender: false,
      show: true
    }

    this.mountRef = React.createRef()
  }

  componentDidMount(): void {
    const currentMount = this.mountRef.current

        const  camera = new THREE.PerspectiveCamera(75,currentMount.clientWidth / currentMount.clientHeight, 0.1, 1000)
        camera.position.set(1,1,1)
    
        //renderer set up
        const renderer = new THREE.WebGLRenderer({antialias: true})
        renderer.setSize(currentMount.clientWidth, currentMount.clientHeight)
        renderer.outputEncoding = THREE.sRGBEncoding;
        currentMount.appendChild(renderer.domElement)
    
        const controls = new OrbitControls(camera, renderer.domElement)
        controls.target = new THREE.Vector3(0,0,0)
        controls.enableDamping = true
        controls.rotateSpeed = -0.4
    
        scene.add(camera)
    
        //create texture for sphere

        THREE.TextureLoader.prototype.crossOrigin = "anonymous";
    
        const loader = new THREE.TextureLoader()
        loader.setCrossOrigin("")
        loader.crossOrigin = ''
        const texture = loader.load("https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" + (this.props.amenityData.links[0].link).replace(' ', '+'), (texture) => {
          texture.encoding = THREE.sRGBEncoding;
          texture.mapping = THREE.EquirectangularReflectionMapping;
        })
        texture.flipY = false
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
        texture.magFilter = THREE.NearestFilter
        
        const material = new THREE.MeshBasicMaterial({side: THREE.BackSide, combine: THREE.MultiplyOperation, envMap: texture})
    
        const geometry = new THREE.SphereGeometry( 32, 32, 32 );
        const sphere = new THREE.Mesh( geometry, material );
        sphere.name = 'viewer360'
        sphere.scale.set(1,1,1)
        scene.add( sphere );
    
    
        //Ambient Ligth
        const AO = new THREE.AmbientLight(0xffffff, 2)
        scene.add(AO)
    
        const animate = () => {
            requestAnimationFrame(animate)
            controls.update()
            renderer.render(scene, camera)
        }
    
        animate()

        const SceneContainer = new ResizeObserver((div) => {
            let rect = div[0].contentRect
            renderer.setSize(rect.width, rect.height)
        })

        const SceneContainerDiv = document.querySelector('#scene-container') as any

        SceneContainer.observe(SceneContainerDiv)
  }

handleSelectRender = (payload: string) => {
    var selectedObject: any = scene.getObjectByName('viewer360')
    const loader = new THREE.TextureLoader()
        loader.setCrossOrigin("")
        loader.crossOrigin = ''
        const texture = loader.load("https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" + (payload).replace(' ', '+'), (texture) => {
          texture.encoding = THREE.sRGBEncoding;
          texture.mapping = THREE.EquirectangularReflectionMapping;
        })
        texture.flipY = false
        texture.wrapS = THREE.RepeatWrapping;
        texture.repeat.x = - 1;
        texture.magFilter = THREE.NearestFilter
        
    const material = new THREE.MeshBasicMaterial({side: THREE.BackSide, combine: THREE.MultiplyOperation, envMap: texture})
    selectedObject.material = material
    selectedObject.dipose()
}

handleRenderSize = () => {
}
    render(){
        return(
            <div className={this.props.isViewer360 ? 'viewer-360-container fade-in':'viewer-360-container fade-out'}>
                {
                    this.props.isViewer360 ?
                    <div className={this.state.isCollapsed ? "gallery-file-container-wide":"gallery-file-container"} >
                        <div ref={this.mountRef} className='scene-container' id='scene-container'>
                        </div>
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-gallery-btn-collapsed':'sidebar-gallery-btn'}
                    onClick={() => {this.props.handleCloseGallery()}}
                >
                    <img src={pill} alt=""/>
                </div>

                <div className={this.state.isCollapsed ? 'sidebar-gallery-container-collapsed':'sidebar-gallery-container'}>
                    <div className='sidebar-gallery-preview-container'>
                        {
                            this.props.amenityData && this.props.amenityData.links ?
                            this.props.amenityData.links.map((render: any, index: number) =>
                                <div className='individual-tour-container' 
                                onClick = {() => {
                                    this.setState({currentImage: render.link, currentSelectedtourIndex: index})
                                }}
                                >
                                    <div 
                                        className='individual-tour-image-container'
                                        style={{
                                            boxSizing: 'border-box',
                                            border: this.state.currentSelectedtourIndex === index ? `0.2vw ${this.props.colorsData.main_buttons} solid`:`none`
                                        }}
                                    >
                                        <img src={"https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" + render.link} alt=""></img>
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Viewer360ThreeMobile